import axios from "axios";
import { buildHeaders } from "./_headers.util";

const API_URL = `${process.env.VUE_APP_API_URL}companies/`;

export default {
  getActivities(companyId) {
    return axios.get(`${API_URL}${companyId}/engagement/activities`, {
      headers: buildHeaders(),
    });
  },

  getNotes(companyId) {
    return axios.get(`${API_URL}${companyId}/notes`, {
      headers: buildHeaders(),
    });
  },

  createNote(companyId, data) {
    return axios.post(`${API_URL}${companyId}/notes`, data, {
      headers: buildHeaders(),
    });
  },

  updateNote(companyId, noteId, data) {
    return axios.put(`${API_URL}${companyId}/notes/${noteId}`, data, {
      headers: buildHeaders(),
    });
  },

  deleteNote(companyId, noteId) {
    return axios.delete(`${API_URL}${companyId}/notes/${noteId}`, {
      headers: buildHeaders(),
    });
  },

  getCalls(companyId) {
    return axios.get(`${API_URL}${companyId}/calls`, {
      headers: buildHeaders(),
    });
  },

  createCall(companyId, data) {
    return axios.post(`${API_URL}${companyId}/calls`, data, {
      headers: buildHeaders(),
    });
  },

  updateCall(companyId, callId, data) {
    return axios.put(`${API_URL}${companyId}/calls/${callId}`, data, {
      headers: buildHeaders(),
    });
  },

  deleteCall(companyId, callId) {
    return axios.delete(`${API_URL}${companyId}/calls/${callId}`, {
      headers: buildHeaders(),
    });
  },

  getFiles(companyId) {
    return axios.get(`${API_URL}${companyId}/files`, {
      headers: buildHeaders(),
    });
  },

  uploadFile(companyId, file) {
    const data = new FormData();
    data.append("file", file);

    return axios.post(`${API_URL}${companyId}/files`, data, {
      headers: buildHeaders({}, { multipart: true }),
    });
  },

  downloadFile(companyId, fileId) {
    return axios.get(`${API_URL}${companyId}/files/${fileId}/download`, {
      headers: buildHeaders(),
      responseType: "blob",
    });
  },

  deleteFile(companyId, fileId) {
    return axios.delete(`${API_URL}${companyId}/files/${fileId}`, {
      headers: buildHeaders(),
    });
  },

  getEmails(companyId) {
    return axios.get(`${API_URL}${companyId}/emails`, {
      headers: buildHeaders(),
    });
  },

  sendEmail(companyId, data) {
    return axios.post(`${API_URL}${companyId}/emails`, data, {
      headers: buildHeaders(),
    });
  },
};
